import { useState } from 'react';

//import resources
import LogoWhite from '../../../assets/images/logowhite.svg';
import { FaTimes } from "react-icons/fa";

//import locales
import { useTranslation } from "react-i18next";
import "../../../i18n";

//import tags
import { toast, Bounce } from 'react-toastify';
import { PulseLoader } from 'react-spinners';

//import api
import FetchData from '../../../api/Api';

export default function ResetModal({handleClick}) {

    //import translation
    const { t } = useTranslation();

     //get data
    const [formData, setFormData] = useState({
        loading: false,
        email: ''
    });

   

    const [message, setMessage] = useState(null);

    function inputChange(e) {

        const { name, value } = e.target;

        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value
        }))
    }

    async function handleResetPassword() {

        setFormData((prevFormData) => ({
            ...prevFormData,
            loading: true
        }))

        try {
            const fetchDataInstance = new FetchData();
            const result = await fetchDataInstance.action(`/api/reset`, formData, false);
            

            if(result?.status === 'OK') {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    loading: false
                }))

                toast.success(t('reset_success'), {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    transition: Bounce,
                });

                handleClick('auth');
            }
    
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setMessage(error.response.data.message || "Unauthorized access.");
            } else {
                setMessage(error.message || "An unexpected error occurred.");
            }

            setFormData((prevFormData) => ({
                ...prevFormData,
                loading: false
            }))
        }
    }

    return (
        <div className="fixed top-0 left-0 z-30 bg-slate-900/70 w-full h-full backdrop-blur-sm flex items-center justify-center">
            <div className="bg-white max-w-[900px] w-full h-full max-h-[700px] rounded-xl relative overflow-hidden">
                <div className="w-[40px] h-[40px] flex items-center justify-center rounded-full bg-gray-200 cursor-pointer absolute top-0 right-0 mt-2 me-2" onClick={()=>handleClick('')}>
                    <FaTimes />
                </div>
                <div className='h-full flex'>
                    <div className='h-full w-[400px] relative'>
                        <img className='absolute top-0 left-0 right-0 bottom-0 m-auto w-[300px]' src={LogoWhite} alt='Celestron' />
                        <img className='h-full w-full object-cover object-left-top' alt='Celestron' src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.dev/svgjs' width='400' height='560' preserveAspectRatio='none' viewBox='0 0 400 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1005%26quot%3b)' fill='none'%3e%3crect width='400' height='560' x='0' y='0' fill='%230e2a47'%3e%3c/rect%3e%3cpath d='M100 67.74C84.47 72.7 83.33 83.92 83.33 100C83.33 115.68 84.78 126.09 100 131.25C143.12 145.88 156.18 149.94 200 139.58C222.28 134.31 232.2 119.55 232.2 100C232.2 81.13 221.79 68.07 200 62.75C155.69 51.94 142.81 54.07 100 67.74' stroke='rgba(253%2c 130%2c 4%2c 0.29)' stroke-width='2'%3e%3c/path%3e%3cpath d='M400 384.62C398.34 395.01 384 392.26 384 400C384 407.84 398.31 405.26 400 415.79C406.31 455.26 400 457.89 400 500C400 539.03 407.24 541.83 400 578.05C397.24 591.83 393.54 597.03 380 600C343.54 608 340 600 300 600C250 600 250 600 200 600C151.09 600 149.42 602.49 102.17 600C99.42 599.86 102.64 595.64 100 594.74C51.56 578.22 30.77 594.31 0 565.15C-19.23 546.94 0 532.58 0 500C0 450 0 450 0 400C0 350 0 350 0 300C0 250 0 250 0 200C0 150 0 150 0 100C0 50 -25 25 0 0C25 -25 50 0 100 0C150 0 150 0 200 0C250 0 250 0 300 0C350 0 375 -25 400 0C425 25 400 50 400 100C400 150 400 150 400 200C400 250 400 250 400 300C400 342.31 406.34 345.01 400 384.62' stroke='rgba(253%2c 130%2c 4%2c 0.29)' stroke-width='2'%3e%3c/path%3e%3cpath d='M200 476.29C173.9 476.29 143.9 486.14 143.9 500C143.9 514.91 175.02 533.82 200 533.82C216.44 533.82 226.74 515.73 226.74 500C226.74 486.96 215.32 476.29 200 476.29' stroke='rgba(253%2c 130%2c 4%2c 0.29)' stroke-width='2'%3e%3c/path%3e%3cpath d='M89.47 0C101 27.67 40.52 50.47 41.67 100C42.84 150.47 76.62 147.49 94.12 200C105.78 234.99 88.66 275 100 275C113.03 275 112.89 224.97 142.86 200C162.89 183.31 172.17 191.67 200 191.67C208.43 191.67 211.91 192.29 215.38 200C236.33 246.46 222.35 257.21 248.84 300C264.66 325.54 276.15 336.67 300 336.67C319.19 336.67 317.27 318.15 334.92 300C367.27 266.75 381 233.87 400 233.87C413.54 233.87 400 266.93 400 300C400 326.28 410.71 330.84 400 352.56C386.05 380.84 350.67 376.12 350.67 400C350.67 424.18 385.83 419.95 400 448.68C410.49 469.95 400 474.34 400 500C400 523.78 409.59 527.49 400 547.56C385.7 577.49 381.02 584.9 352.22 600C331.02 611.12 326.11 600 300 600C250 600 250 600 200 600C178.26 600 156.52 606.66 156.52 600C156.52 591.96 181.71 589.01 200 570.59C231.35 539.01 255.81 532.83 255.81 500C255.81 472.79 233.04 457.59 200 450.52C155.13 440.92 144.76 449.37 100 466.67C80.76 474.11 90.06 489.06 72 500C40.06 519.36 26.58 527.27 0 527.27C-9.42 527.27 0 513.63 0 500C0 467.86 -11.24 462.68 0 435.71C9.59 412.68 26.05 422.08 41.67 400C74.05 354.22 107.01 335.22 96 300C86.17 268.55 28.98 296.86 0 266.67C-19.02 246.86 0 233.34 0 200C0 150 0 150 0 100C0 50 -23.61 26.39 0 0C21.12 -23.61 80.16 -22.33 89.47 0' stroke='rgba(253%2c 130%2c 4%2c 0.29)' stroke-width='2'%3e%3c/path%3e%3cpath d='M200 13.73C174.88 -4.44 136.36 3.47 136.36 0C136.36 -3.39 168.18 0 200 0C250 0 250 0 300 0C350 0 353.84 -3.84 400 0C403.84 0.32 402.11 4.79 400 8.33C372.38 54.79 373.33 56.64 340.54 100C323.33 122.75 317.98 140.54 300 140.54C285 140.54 289.36 118.74 274.58 100C239.36 55.34 243.99 45.56 200 13.73' stroke='rgba(253%2c 130%2c 4%2c 0.29)' stroke-width='2'%3e%3c/path%3e%3cpath d='M23.68 0C23.68 40.64 6 100 0 100C-5.84 100 -9.57 40.43 0 0C2.27 -9.57 23.68 -9.36 23.68 0' stroke='rgba(253%2c 130%2c 4%2c 0.29)' stroke-width='2'%3e%3c/path%3e%3cpath d='M300 37.5C288.29 37.5 275 12.06 275 0C275 -6.69 287.5 0 300 0C310.35 0 320.69 -6.11 320.69 0C320.69 12.64 311.13 37.5 300 37.5' stroke='rgba(253%2c 130%2c 4%2c 0.29)' stroke-width='2'%3e%3c/path%3e%3cpath d='M0 100C11.8 100 45.1 156.13 45.1 200C45.1 222.1 14.29 231.94 0 231.94C-8.26 231.94 0 215.97 0 200C0 150 -10.75 100 0 100' stroke='rgba(253%2c 130%2c 4%2c 0.29)' stroke-width='2'%3e%3c/path%3e%3cpath d='M374.6 300C374.6 287.82 392.59 274.19 400 274.19C405.29 274.19 400 287.1 400 300C400 310.25 404.9 320.51 400 320.51C392.2 320.51 374.6 310.98 374.6 300' stroke='rgba(253%2c 130%2c 4%2c 0.29)' stroke-width='2'%3e%3c/path%3e%3cpath d='M131.43 400C131.43 366.81 159.51 319.49 200 314.29C243.8 308.66 252.45 343.59 300 378.33C311.11 386.45 307.69 390.04 317.33 400C357.69 441.67 364.32 438.42 400 481.58C405.66 488.42 400 490.79 400 500C400 508.54 404.99 510.47 400 517.07C367.21 560.47 365.5 565.95 324.44 600C315.5 607.42 312.22 600 300 600C259.26 600 221.58 620.22 218.52 600C214.02 570.22 289.64 545.05 284.88 500C280.38 457.42 246.71 455.18 200 424.74C169.98 405.18 131.43 422.04 131.43 400' stroke='rgba(253%2c 130%2c 4%2c 0.29)' stroke-width='2'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1005'%3e%3crect width='400' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e" />
                    </div>
                    <div className='w-[calc(100%-400px)] p-5 px-10'>
                         
                         <div className='upper text-2xl font-bold text-center w-full mt-8 mb-3'>{t('reset')}</div>
                         <div className='text-gray-500 mb-10 text-center text-sm'>{t('reset_text')}</div>
                         <div className=''>
                            <div className='mb-5'>
                                <label htmlFor="email" className="block text-sm text-gray-700 mb-2">{t('email')}</label>
                                <input value={formData.email} onChange={(e)=>inputChange(e)} type="email" name="email" id="email" placeholder={t('enter_email')} className="block w-full h-[52px] rounded-3xl border border-gray-300 px-4 text-sm focus:border-blue-500 focus:ring-blue-500 outline-none" />
                            </div>

                            {
                                message ? 
                                    <div className='col-span-12 text-[13px] bg-red-100 text-red-700 p-2 rounded-3xl text-center'>{message}</div>
                                :
                                ''
                            }

                            <div>
                                <button onClick={handleResetPassword} className='bg-[var(--orange)] rounded-3xl px-12 py-3.5 text-white mx-auto block mt-5'>
                                    {
                                        formData.loading ?
                                            <PulseLoader size="8" color="#fff" />
                                        :
                                        t('reset')
                                    }
                                </button>
                            </div>
                            <div className='relative w-[80px] mx-auto text-center font-bold mt-7 text-sm before:content-[""] before:bg-[var(--orange)] before:w-[150px] before:h-[1px] before:absolute before:left-0 before:top-0 before:-ms-[150px] before:mt-2 after:content-[""] after:bg-[var(--orange)] after:w-[150px] after:h-[1px] after:absolute after:right-0 after:top-0 after:-me-[150px] after:mt-2'>
                                {t('or')} 
                            </div>
                            <div className='mt-7 text-center'>{t('please')} <span className='cursor-pointer text-[var(--orange)] font-bold' onClick={()=>handleClick('auth')}>{t('login')} </span></div>
                         </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
